<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-job-position-job-band-dialog-create
          v-if="$hasPermissionTo(['create job bands'])" 
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Job Band/Grade's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in job band/grade value here"
          append-icon="search"
          label="Search Job Band/Grade"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredJobBands"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.value }}</td>
          <td>
            <span v-if="statusFilter">
              <setup-job-position-job-band-dialog-edit
                v-if="$hasPermissionTo(['update job bands'])" 
                :job-band="props.item"
                @updated="loadData"
              />
              <span class="mx-1" />
              <setup-job-position-job-band-dialog-delete
                v-if="$hasPermissionTo(['delete job bands'])" 
                :job-band="props.item"
                @deleted="loadData"
              />
            </span>
            <span v-else>
              <setup-job-position-job-band-dialog-restore
                v-if="$hasPermissionTo(['restore job bands'])" 
                :job-band="props.item"
                @restored="loadData"
              />
            </span>
          </td>
        </tr>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobBandDialogCreate: () => import('@/components/hris/setup/job-position/job-band/DialogCreate'),
      SetupJobPositionJobBandDialogDelete: () => import('@/components/hris/setup/job-position/job-band/DialogDelete'),
      SetupJobPositionJobBandDialogRestore: () => import('@/components/hris/setup/job-position/job-band/DialogRestore'),
      SetupJobPositionJobBandDialogEdit: () => import('@/components/hris/setup/job-position/job-band/DialogEdit'),
    },
    data () {
      return {
        jobBands: [],
        trashedJobBands: [],
        headers: [
          {
            text: 'Value',
            align: 'left',
            value: 'value',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredJobBands () {
        return this.statusFilter ? this.jobBands : this.trashedJobBands
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobBands().list(),
          this.$api.jobBands().listTrashed(),
        ]).then(([jobBands, trashedJobBands]) => {
          this.jobBands = jobBands.data
          this.trashedJobBands = trashedJobBands.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
